import * as yup from 'yup'

import 'configs/yup'

export const schema = yup.object().shape({
  name: yup.string().trim().required().min(3),
  responsibleIds: yup.array(),
  customizable: yup.boolean(),
  deadlineDay: yup.number().required().min(1),
  companyDeadlineDay: yup
    .number()
    .required()
    .min(1)
    .when('deadlineDay', (deadlineDay, schemaItem) =>
      deadlineDay
        ? schemaItem.max(deadlineDay, 'Não pode ser maior que o prazo total')
        : schemaItem,
    ),
})

export default schema
